const APP_WEBVIEW_LOCAL_STORAGE_KEY = 'app';

export function isAppWebview(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem(APP_WEBVIEW_LOCAL_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}
